const multipleParagraphs = (text, splitter) => {
  return text.split(splitter)
}

export default multipleParagraphs
